import { render, staticRenderFns } from "./ImageGroupUploadZone.vue?vue&type=template&id=2768f676&scoped=true"
import script from "./ImageGroupUploadZone.vue?vue&type=script&lang=js"
export * from "./ImageGroupUploadZone.vue?vue&type=script&lang=js"
import style0 from "./ImageGroupUploadZone.vue?vue&type=style&index=0&id=2768f676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768f676",
  null
  
)

export default component.exports